import { Routes } from '@angular/router';
import { MainLayoutComponent } from './shared/layouts/main-layout/main-layout.component';
import { CustomerLayoutComponent } from './shared/layouts/customer-layout/customer-layout.component';
import { AuthenticationLayoutComponent } from './shared/layouts/authentication-layout/authentication-layout.component';
import { LandingLayoutComponent } from './shared/layouts/landing-layout/landing-layout.component';
import { content } from './shared/routes/content.route';
import { custom } from './shared/routes/customer.routes';
import { authen } from './shared/routes/auth.route';
import { guestGuard } from './shared/auth/auth.guard';

export const routes: Routes = [
    { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
      {
        path: 'auth/login',
        loadComponent: () =>
          import('../app/auth/login/login.component').then((m) => m.LoginComponent),
        canActivate: [guestGuard]
      },
      {
        path: 'auth/new-password',
        loadComponent: () =>
          import('../app/auth/new-password/new-password.component').then((m) => m.NewPasswordComponent),
        canActivate: [guestGuard]
      },
      {
        path: 'auth/forgot-password',
        loadComponent: () =>
          import('../app/auth/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
        canActivate: [guestGuard]
      },
    { path: '', component: MainLayoutComponent, children: content },
    { path: '', component: CustomerLayoutComponent, children: custom },
    { path: '', component: AuthenticationLayoutComponent, children: authen },
    { path: '', component: LandingLayoutComponent, children: authen },
];
